import { session, local, Tools, Type, Assert } from 'me-view/lib/script/index'
export default {
  get systemSession () {
    return session.get('system-session')
  },
  set systemSession (value) {
    session.set('system-session', value)
  },
  get config () {
    return session.get('system-config')
  },
  set config (value) {
    session.set('system-config', value)
  },
  get authorization () {
    return session.get('authorization')
  },
  set authorization (value) {
    session.set('authorization', value)
  },
  set menus (value) {
    session.set('system-menus', value)
  },
  get menus () {
    return session.get('system-menus', { defaultValue: {} })
  },

  set buttons (value) {
    session.set('system-buttons', value)
  },
  get buttons () {
    return session.get('system-buttons', { defaultValue: {} })
  },

  set userInfo (value) {
    session.set('system-userInfo', value)
  },
  get userInfo () {
    return session.get('system-userInfo')
  },

  set systemDict (value = { }) {
    session.set('system-dict', value)
  },

  get systemDict () {
    return session.get('system-dict')
  },

  ignoringRoute (path) {
    return (session.get('system-ignoring-route') || []).includes(path)
  },

  ignoringWatermark (path) {
    return (session.get('system-ignoring-watermark') || []).includes(path)
  },

  ignoringWatermarkPush (list = []) {
    const ignoringList = session.get('system-ignoring-watermark') || []
    const converter = {}
    for (const item of [ ...ignoringList, ...list ]) {
      Reflect.set(converter, item, true)
    }
    session.set('system-ignoring-watermark', Object.keys(converter))
  },

  ignoringRoutePush (list = []) {
    const ignoringList = session.get('system-ignoring-route') || []
    const converter = {}
    for (const item of [ ...ignoringList, ...list ]) {
      Reflect.set(converter, item, true)
    }
    session.set('system-ignoring-route', Object.keys(converter))
  },
  dictList (value) {
    return Reflect.get(this.systemDict || {}, value) || []
  },
  parseUniqueKey (target = {}) {
    const { systemCode, url, multiple } = target
    if (Reflect.has(target, 'uniqueKey')) {
      return { ...target }
    }
    const [ pathName ] = (url || '').split('?')
    const uniqueKey = `${systemCode}_${multiple === true ? url : pathName.replace(/\//g, '_')}`
    Object.assign(target, { uniqueKey })
    return { uniqueKey, pathName }
  },
  /**
   * 判断是否拥有指定按钮
   *
   * @param {String} url 接口地址
   */
  ownButton (url) {
    if (this.config.systemVerifyButton === false) { return true }
    return Reflect.has(this.buttons, url)
  },

  /**
   * 判断是否拥有指定菜单
   *
   * @param {String} url 接口地址
   */
  ownMenu (url) {
    if (this.config.systemVerifyPage === false) { return true }
    return Reflect.has(this.menus, url)
  },

  /**
   * 跳转网址
   * @param {String} url 网址
   */
  sendRedirect (url, target = window) {
    console.debug('本次跳转的路径为:', url)
    target.location.href = url
  },
  systemLogout () {
    session.clear()
    local.clear()
    if (Type.isFunction(window.tokenInvalidRedirectCustom)) {
      try {
        if (window.tokenInvalidRedirectCustom() === true) { return }
      } catch (error) {
        console.debug('uitl.sendRedirect --> window.tokenInvalidRedirectCustom error: ', error)
      }
    }
    if (window.top === window) {
      this.sendRedirect(this.config?.systemDomainPortal || '/login')
    } else {
      window.top.postMessage({ action: 'logout' }, '*')
    }
  },
  /**
   * 关闭门户 tab 页签
   * @param {String} systemCode 菜单所属系统
   * @param {String} url 菜单相对URL 地址
   * @param {String} origin Location.origin
   * @param {Boolean} delay 延迟打开
   * @param {Number} delayTime 延迟打开时间， 默认2秒
   * @param {Boolean} multiple 是否多打开
   */
  closeTab ({ url, params, target = '_blank', delay = false, delayTime = 2 * 1000, ...other } = {}) {
    console.debug('util -> closeTab begin...')
    if (window.top === window) {
      return
    }
    console.debug('通知父级关闭选项卡...')
    const options = {
      url,
      action: 'closeTabPane',
      systemCode: this.config.systemCode,
      origin: location.origin,
      params,
      ...other
    }
    if (delay) {
      setTimeout(() => {
        window.top.postMessage(options, '*')
      }, delayTime)
    } else {
      window.top.postMessage(options, '*')
    }
  },
  /**
   * 新开窗口
   * @param {String} systemCode 菜单所属系统
   * @param {String} title 菜单标题
   * @param {String} url 菜单相对URL 地址
   * @param {JsonObject} params 参数
   * @param {String} origin Location.origin
   * @param {Boolean} multiple 是否多打开
   * @param {Boolean} iframe 内嵌iframe 打开
   * @param {Boolean} closable 是否可关闭，默认：true
   */
  openTab ({ url, params, iframe = false, target = '_blank', ...other } = {}) {
    Assert.notEmpty(url, '参数 url 不能为空')
    console.debug('程序开始打开新窗口，原始地址:', url)
    if (iframe === false && window.top === window) {
      let newUrl = Tools.urlAbsolutize(url, other.origin)
      if (Type.isObject(params)) {
        const stringifyValue = Tools.stringify(params)
        if (Tools.notEmpty(stringifyValue)) {
          newUrl = newUrl.replace(/([?&]+)$/, '').includes('?') ? '&' : '?'
          newUrl += stringifyValue
        }
      }
      window.open(newUrl, target)
      return
    }
    console.debug('通知父级打开选项卡...')
    window.top.postMessage({
      url,
      action: 'openTabPane',
      systemCode: this.config.systemCode,
      origin: location.origin,
      params,
      ...other
    }, '*')
  },
  /**
   * 心跳广播
   * @param {String} param.triggerOrigin 触发广播的源
   */
  heartbeatBroadcast ({ triggerOrigin } = {}) {
    const iframeList = document.querySelectorAll('iframe[name^=frame-open-menu--]')
    if (iframeList && iframeList.length > 0) {
      const broadcastOrigin = {}
      for (const iframe of iframeList) {
        if (Reflect.get(broadcastOrigin, iframe.name) === true) { continue }
        try {
          iframe.contentWindow.postMessage({ action: 'heartbeat', triggerOrigin }, '*')
        } catch (error) { console.log(`iframe.name= ${iframe.name} 心跳广播失败`, error) }
        Reflect.set(broadcastOrigin, iframe.name, true)
      }
    }
  },
  /**
   * 触发向其他系统同步会话
   */
  synchronizeSession () {
    const data = new Date().getTime()
    const systemSession = this.systemSession || {}
    this.systemSession = Object.assign(systemSession, { timeOperate: data })

    const { systemExpiration = 2 * 60 * 60 * 1000 } = this.config
    let { timeSynchronize = data } = systemSession

    if (data > timeSynchronize + systemExpiration / 4) {
      /** 四分之一过期时间 同步一次会话 */
      timeSynchronize = data /** 更新同步时间 */
      if (window.top !== window) {
        window.top.postMessage({
          action: 'heartbeat-trigger',
          triggerOrigin: window.location.origin
        }, '*')
      }
    }
    this.systemSession = Object.assign(systemSession, { timeSynchronize, timeOperate: data })
  }
}
